/**
 * Created by aleco on 9/26/2017.
 */

import { Component, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ServiceComponent } from "../service.component";
import { Service } from "../../../../entities/service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ServiceService } from "../../../../services/service.service";
import { FileItem, FileUploader, ParsedResponseHeaders } from "ng2-file-upload";
import { Router } from "@angular/router";
import { SharedService } from 'src/app/services/sharedService';
import { TasService } from 'src/app/services/tas.service';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/entities/user';
import {FetchType} from "./csv-upload.component";
import {ExternalApiGatewayService} from "../../../../services/external-api-gateway.service";
import {ToastrService} from "ngx-toastr";
import {finalize} from "rxjs/internal/operators";

@Component({
  selector: '<ntr-service-csv>',
  templateUrl: './service-csv.component.html'
})
export class ServiceCsvComponent implements ServiceComponent, OnInit {
  ngOnInit(): void {
     this.userService.getCurrentUser().subscribe(user => {
         this.user = user;
     });
  }
  @ViewChild('fileUpload', { static: false }) selectedFile: any;
  
  @Input() currencies: any[];
  @Input() service: Service;
  modalRef: BsModalRef;
  modalRefErrorMessage: BsModalRef;
  selectedFileFormat = {};
  errorMessage: string;
  @ViewChild('informationTemplate', { static: false })
  private informationTemplate: TemplateRef<any>;
  public uploader: FileUploader;
  public hasBaseDropZoneOver: boolean = false;
  public hasAnotherDropZoneOver: boolean = false;
  fileFormatId: any;
  user: User;
  activeId: any;
  
  constructor(private modalService: BsModalService,
              private userService: UserService,
              private serviceService: ServiceService,
              private router: Router,
              public tasService: TasService,
              public sharedService: SharedService,
              private externalApiService: ExternalApiGatewayService,
              private alertService: ToastrService) {
    this.uploader = new FileUploader({url: sharedService.apiUrl('api/services')+'csv_file_upload',
    authToken: "Bearer " + localStorage.getItem('access_token'),
  });
    this.uploader.onBuildItemForm = (item, form) => {
      form.append("serviceId", this.service.id);
      form.append("fileFormatId", this.fileFormatId);
      form.append("serviceName", this.service.name);
      form.append("fileFormatName", this.service.fileFormats.find(fileFormat => fileFormat['id'] === this.fileFormatId)['name']);
    };
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response); //success server response
    this.router.navigateByUrl('/batch-process/'+data);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  openModalMessage(template: TemplateRef<any>) {
    this.modalRefErrorMessage = this.modalService.show(template, {class: 'modal-sm'});
  }


  confirmDeletion(serviceId, id): void {
    this.deleteFileFormat(serviceId, id);
    this.modalRef.hide();
  }
 

  confirmDuplication(id, name): void {
    var formatToDuplicate = this.service.fileFormats.find(fileFormat => fileFormat['id'] === id);
    formatToDuplicate['id'] = null;
    formatToDuplicate['name'] = name;
    formatToDuplicate['serviceId'] = this.service.id
    this.serviceService.addFileFormat(formatToDuplicate).subscribe(service => {
      this.serviceService.updateService(service);
      this.modalRef.hide();
    }, error => {
      this.errorMessage = 'ERRORS.' + error.code;
      this.openModalMessage(this.informationTemplate);
    });
  }
  fetchFromTas(fileFormat){
    let fileformatId = fileFormat.id
    let declarationId = fileFormat.declarationId
    let stageKey = fileFormat.stageKey
    let blockKey = fileFormat.blockKey
    this.tasService.getTasTableData(declarationId, stageKey, blockKey, fileformatId, fileFormat.name, this.service.id, this.service.name).subscribe(data => {
      
    })
  }
  // fetchingFromApi = false
  fetchFromApi(fileFormat){
    let fileformatId = fileFormat.id
    fileFormat['fetchingFromApi'] = true
    setTimeout(() => {
      this.externalApiService.fetchData$(fileformatId).pipe(
          finalize(() => {
            fileFormat['fetchingFromApi'] = false
          })
      ).subscribe({
        next: (data) => {
          this.alertService.success('Fetched data from API')
        },
        error: (err) => {
          this.alertService.error('Error fetching data from API')
          console.error('Error occurred:', err);
        }
      })
    }, 0)


  }


  deleteFileFormat(serviceId, id) {
    var fileFormat = {serviceId: serviceId, id: id}
    this.serviceService.deleteFileFormat(fileFormat)
      .subscribe(service => {
        this.serviceService.updateService(service);
      });
  }

  decline(): void {
    this.modalRef.hide();
  }

  closeModalMessage(): void {
    this.modalRefErrorMessage.hide();
  }

  showFileFormat(value: Object) {
      this.selectedFileFormat = value;
      this.sharedService.changeFileFormatEmit(this.selectedFileFormat)
      this.detectActiveId()
  }

  detectActiveId(){
    this.activeId = !this.selectedFileFormat || !this.selectedFileFormat['fusionImport'] ? 1 : 2
    if (this.selectedFileFormat && this.selectedFileFormat['fusionImport'])
      this.activeId = 2
    if (this.selectedFileFormat && this.selectedFileFormat['externalApiGateway']?.api)
      this.activeId = 3
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  clearSelectedFile(){
    this.selectedFile.nativeElement.value = '';
  }

  protected readonly FetchType = FetchType;
}
